import React from "react";
import { Link } from 'react-router-dom';

export default class HeaderLogo extends React.Component {
    render() {
        return (
            <Link to="/"><img src={"./images/"+this.props.logoContent} alt="BT&amp;T Logo" className="logo" /></Link>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/header/logo.js